import { useLazyQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { oAuthProviderConfigurationSchemaQuery, } from 'apis/partnerIntegrations';
/** A hook to retrieve the OAuth strategy schema. */
export const useLazyReadOAuthStrategySchema = () => {
    const [oAuthSchema, setOAuthSchemaSchema] = useState([]);
    const [readOAuthStrategySchema, { data: schemaData, loading: isSchemaLoading, error: oAuthSchemaError },] = useLazyQuery(oAuthProviderConfigurationSchemaQuery);
    useEffect(() => {
        if (!isSchemaLoading && schemaData) {
            setOAuthSchemaSchema(schemaData.Management.oAuthProviderConfigurationSchema);
        }
    }, [schemaData, isSchemaLoading]);
    return {
        oAuthSchema,
        isSchemaLoading,
        isOAuthSchemaError: !!oAuthSchemaError,
        readOAuthStrategySchema,
        setOAuthSchemaSchema,
    };
};
